import { LanguageConfig, LanguageCode } from '@bv/types/plugins/i18n';

export enum I18nConst {
  appTitle = 'global.app_title_trans',
}

export const LANGUAGES: LanguageConfig[] = [
  {
    code: LanguageCode.EN,
    name: 'English',
    shortName: 'EN',
    transKey: 'global.language.en',
    icon: 'bvi-flag-uk-colored',
  },
  {
    code: LanguageCode.AR,
    name: 'العربية',
    shortName: 'ع',
    transKey: 'global.language.ar',
    icon: 'bvi-flag-sa-colored',
    isRtl: true,
  },
];
